<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:02:18
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-11 14:08:26
-->
<template>
  <div :style="{height:height}" class="content">
    <div class="top">
      <div class="top-btn">
        <el-button  type="primary"
          >评分详情</el-button
        >
      </div>
      <div class="search">
        <el-select
          v-model="valueSite"
          placeholder="请选择"
          style="width: 310px; margin-right: 20px"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.id"
            :label="item.name"
            :value="`${item.id}`"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="valueTime"
          placeholder="请选择"
          style="width: 200px; margin-right: 20px"
        >
          <el-option
            v-for="item in ['2022年9月', '2022年8月', '2022年7月', '2022年6月']"
            :key="item"
            :label="item"
            :value="`${item}`"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="getListPage">查询</el-button>
      </div>
    </div>
    <div class="box">
      <div class="cont-one">
        <div class="one-box">
          <div style="display: flex; align-items: center; font-weight: bold">
            <div class="tab-tips"></div>
            <div>站点可用性</div>
          </div>
          <div>
            <div class="tong-ji">
              <div id="gender-chart" class="gender-chart"></div>
              <div class="tong-txt">
                <div>
                  <div class="txt-one">
                    <div>正常次数:</div>
                    <div>99</div>
                  </div>
                </div>
                <div>
                  <div class="txt-one">
                    <div>故障次数:</div>
                    <div>1</div>
                  </div>
                </div>
                <div>
                  <div class="txt-one">
                    <div>故障比列:</div>
                    <div>1%</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tips-box">
                <div style="margin-right:14px" class="tips-left">
                    <div class="dian-left"></div>
                    <div class="dian-txt">正常次数</div>
                </div>
                <div class="tips-left">
                    <div class="dian-rigth"></div>
                    <div class="dian-txt">正常次数</div>
                </div>
            </div>
          </div>
        </div>
        <div class="one-box">
           <div class="dan-xiang">
              <div style="display: flex; align-items: center; font-weight: bold">
                <div class="tab-tips"></div>
                <div>单项否决</div>
            </div>
            <div class="he-ge">合格</div>
           </div>
           <div style="margin-top:24px" class="dan-xiang-one">
              <div class="dan-xiang-txt">站点可用性：</div>
              <div class="dan-xiang-txt">合格</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">首页不更新监控：</div>
              <div class="dan-xiang-txt">合格</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">栏目不更新监控：</div>
              <div class="dan-xiang-txt">合格</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">互动回应监控：</div>
              <div class="dan-xiang-txt">合格</div>
           </div>
        </div>
        <div class="one-box">
          <div style="display: flex; align-items: center; font-weight: bold">
            <div class="tab-tips"></div>
            <div>链接可用性</div>
          </div>
          <div>
            <div class="tong-ji">
              <div id="link-chart" class="gender-chart"></div>
              <div class="tong-txt">
                <div>
                  <div class="txt-one">
                    <div>正确链接数:</div>
                    <div>100000</div>
                  </div>
                </div>
                <div>
                  <div class="txt-one">
                    <div>首页错链接数:</div>
                    <div>0</div>
                  </div>
                </div>
                <div>
                  <div class="txt-one">
                    <div>其他页错链数:</div>
                    <div>0</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tips-box-two">
                <div style="margin-right:14px" class="tips-left">
                    <div class="dian-left"></div>
                    <div class="dian-txt">正确链接数</div>
                </div>
                <div style="margin-right:14px" class="tips-left">
                    <div style="background:#f6c029;" class="dian-rigth"></div>
                    <div class="dian-txt">首页错链接数</div>
                </div>
                 <div  class="tips-left">
                    <div class="dian-rigth"></div>
                    <div class="dian-txt">其他页错链数</div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont-one">
        <div class="one-box">
          <div style="display: flex; align-items: center; font-weight: bold">
            <div class="tab-tips"></div>
            <div>首页不更新监控</div>
          </div>
            <div id="home" class="home-box"></div>
            <div class="nei-rong">
                 <div style="background:#1890ff" class="dian-left"></div>
                 <div>内容发布</div>
            </div>
        </div>
        <div class="one-box">
           <div class="dan-xiang">
              <div style="display: flex; align-items: center; font-weight: bold">
                <div class="tab-tips"></div>
                <div>综合扣分项评分结果</div>
            </div>
            <div class="he-ge">100分</div>
           </div>
           <div style="margin-top:24px" class="dan-xiang-one">
              <div class="dan-xiang-txt">链接可用性：</div>
              <div class="dan-xiang-txt">-0分</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">栏目更新情况：</div>
              <div class="dan-xiang-txt">-0分</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">办理答复情况：</div>
              <div class="dan-xiang-txt">-0分</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">留言公开情况：</div>
              <div class="dan-xiang-txt">-0分</div>
           </div>
        </div>
        <div class="one-box">
          <div style="display: flex; align-items: center; font-weight: bold">
            <div class="tab-tips"></div>
            <div>栏目不更新</div>
          </div>
          <div>
            <div class="tong-ji">
              <div id="four-chart" class="gender-chart"></div>
              <div class="tong-txt">
                <div>
                  <div class="txt-one">
                    <div>正常栏目数:</div>
                    <div>191</div>
                  </div>
                </div>
                <div>
                  <div class="txt-one">
                    <div>不更新:</div>
                    <div>12</div>
                  </div>
                </div>
                <div>
                  <div class="txt-one">
                    <div>空白栏目数:</div>
                    <div>3</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tips-box-two">
                <div style="margin-right:14px" class="tips-left">
                    <div class="dian-left"></div>
                    <div class="dian-txt">正常栏目数</div>
                </div>
                <div style="margin-right:14px" class="tips-left">
                    <div style="background:#f6c029;" class="dian-rigth"></div>
                    <div class="dian-txt">不更新</div>
                </div>
                 <div  class="tips-left">
                    <div class="dian-rigth"></div>
                    <div class="dian-txt">空白栏目数</div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cont-one">
        <div style="padding-bottom:12px" class="one-box">
           <div class="dan-xiang">
              <div style="display: flex; align-items: center; font-weight: bold">
                <div class="tab-tips"></div>
                <div>互动回应监控</div>
            </div>
           </div>
           <div style="margin-top:24px" class="dan-xiang-one">
              <div class="dan-xiang-txt">来信总数：</div>
              <div class="dan-xiang-txt">678123</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">已回应：</div>
              <div class="dan-xiang-txt">127893</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">未回应：</div>
              <div class="dan-xiang-txt">89021</div>
           </div>
            <div class="dan-xiang-one">
              <div class="dan-xiang-txt">超3个月未回应：</div>
              <div class="dan-xiang-txt">23</div>
           </div>
        </div>
        <div class="one-box">
          <div style="display: flex; align-items: center; font-weight: bold">
            <div class="tab-tips"></div>
            <div>留言公开情况</div>
          </div>
          <div class="gong-box">
                <div class="gong-kai">
                    <img class="gong-img" src="@/assets/images/liuyan.jpg"/>
                    <div>
                         <div class="gong-kai-num">10000</div>
                         <div class="gong-kai-txt">公开总数</div>
                    </div>
                </div>
                 <div class="gong-kai">
                    <img class="gong-img" src="@/assets/images/liuyan.jpg"/>
                    <div>
                         <div class="gong-kai-num">10000</div>
                         <div class="gong-kai-txt">两月内公开数</div>
                    </div>
                </div>
            </div>
        </div>
          <div class="one-box">
          <div style="display: flex; align-items: center; font-weight: bold">
            <div class="tab-tips"></div>
            <div>办理答复情况</div>
          </div>
          <div class="gong-box">
                <div class="gong-kai">
                    <img class="gong-img" src="@/assets/images/liuyan.jpg"/>
                    <div>
                         <div class="gong-kai-num">10000</div>
                         <div class="gong-kai-txt">已回复</div>
                    </div>
                </div>
                 <div class="gong-kai">
                    <img class="gong-img" src="@/assets/images/liuyan.jpg"/>
                    <div>
                         <div class="gong-kai-num">10000</div>
                         <div class="gong-kai-txt">5个工作日未回复</div>
                    </div>
                </div>
                 <div class="gong-kai">
                    <img class="gong-img" src="@/assets/images/liuyan.jpg"/>
                    <div>
                         <div class="gong-kai-num">10000</div>
                         <div class="gong-kai-txt">未回复</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { list } from "./site_evaluation";
import echarts from "echarts";
export default {
  data() {
    return {
      selectOptions: [],
      valueSite: sessionStorage.getItem("siteId"),
      valueTime: "2022年9月",
      height:0,
      option: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: 10,
          data: ["正常次数", "故障次数"],
          itemHeight: 7,
          itemWidth: 7,
          show: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            labelLine: {
              show: false,
            },
            label: {
              show: false,
              position: "center",
            },
            color: ["#04cb80", "#ff7875"],
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            data: [
              {
                value: 99,
                name: "正常次数",
              },
              {
                value: 1,
                name: "故障次数",
              },
            ],
          },
        ],
      },
      optionTwo:{
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: 10,
          data: ["正确链接数",'首页错链接数', "其他页错链数"],
          itemHeight: 7,
          itemWidth: 7,
          show: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            labelLine: {
              show: false,
            },
            label: {
              show: false,
              position: "center",
            },
            color: ["#04cb80",'#f6c029',"#ff7875"],
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            data: [
              {
                value: 100000,
                name: "正确链接数",
              },
              {
                value: 4000,
                name: "首页错链接数",
              },
              {
                value: 1000,
                name: "其他页错链数",
              },
            ],
          },
        ],
      },
      optionThree:{
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun','Sun','Sun','Sun','Sun'],
                show:false,
            },
            yAxis: {
                type: 'value',
                show:false,
            },
             series: [
            {
              name: '邮件营销',
              type: 'line',
              stack: '总量',
              itemStyle: {
                normal: {
                  color:'#1890ff',
                  areaStyle: {
                    type: 'default',
                    //渐变色实现===
                    color: '#d1e9ff',
                  },
                  lineStyle: {  //线的颜色
                    color: '#1890ff'
                  },
                  //以及在折线图每个日期点顶端显示数字
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: 'white'
                    }
                  }
                },
              },
              areaStyle: {},
              data: [120, 132, 101, 134, 90, 230, 210,120,90,120, 132, 101, 134, 90, 230, 210,120,90,90, 230, 210,120,90]
            }
          ]
        },
         optionFour:{
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: 10,
          data: ["正常栏目数",'不更新', "空白栏目数"],
          itemHeight: 7,
          itemWidth: 7,
          show: false,
        },
        height:0,
        series: [
          {
            name: "",
            type: "pie",
            radius: ["45%", "60%"],
            avoidLabelOverlap: false,
            labelLine: {
              show: false,
            },
            label: {
              show: false,
              position: "center",
            },
            color: ["#04cb80",'#f6c029',"#ff7875"],
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            data: [
              {
                value: 100000,
                name: "正确链接数",
              },
              {
                value: 4000,
                name: "首页错链接数",
              },
              {
                value: 1000,
                name: "其他页错链数",
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    this.getList();
    var chartDom = document.getElementById("gender-chart");
    var myChart = echarts.init(chartDom);
    this.option && myChart.setOption(this.option);

    var chartDomTwo = document.getElementById("link-chart");
    var myChartTwo = echarts.init(chartDomTwo);
    this.optionTwo && myChartTwo.setOption(this.optionTwo);

    var chartDomThree = document.getElementById("home");
    var myChartThree = echarts.init(chartDomThree);
    this.optionThree && myChartThree.setOption(this.optionThree);

     var chartDomFour = document.getElementById("four-chart");
    var myChartFour = echarts.init(chartDomFour);
    this.optionFour && myChartFour.setOption(this.optionFour);
    this.height = (document.documentElement.clientHeight -110)+'px';
    window.onresize = () => {
      return (() => {
         this.height = (document.documentElement.clientHeight -110)+'px';
      })();
    };
    

  },
  methods: {
    getList() {
      list({}).then((res) => {
        if (res.code == 0) {
          this.selectOptions = res.data;
        }
      });
    },
    getListPage() {},
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
  }
  /deep/.ant-select-selection {
    background: #f7f7f7;
    border-right: none;
    border-radius: none;
    border-top-right-radius: none;
    border-bottom-right-radius: none;
    border-top-left-radius: 4px;
  }
  /deep/ .ant-input {
    background: #f7f7f7;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #415058;
  }
  /deep/ .ant-select-selection__placeholder {
    color: #415058;
  }
  /deep/ .icon-edit-excel:before {
    color: #fff;
  }
  .icon-box {
    margin-right: 4px;
  }
}
/deep/.el-input__inner {
  background-color: rgba(245, 247, 250, 1);
}
.tab-tips {
  width: 4px;
  height: 14px;
  background: #1890ff;
  margin-right: 8px;
}
.cont-one {
  display: flex;
  margin-bottom: 20px;
  .one-box {
    flex: 1;
    margin-right: 20px;
    padding-left: 20px;
    padding-top: 24px;
    padding-right: 36px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    position: relative;
  }
  .one-box:last-child {
    margin-right: 0px;
  }
}
.box {
  padding: 24px;
}
.gender-chart {
  width: 200px;
  height: 200px;
}
.tong-ji {
  display: flex;
  align-items: center;
  .tong-txt {
    flex: 1;
  }
  .txt-one {
    display: flex;
    justify-content: space-between;
    font-family: Roboto-regular;
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    margin-bottom: 12px;
  }
}
.dian-left{
    width: 8px;
    height: 8px;
    background-color: rgba(4, 203, 128, 1);
    margin-right: 6px;
}   
.dian-rigth{
    width: 8px;
    height: 8px;
    background-color: rgba(248, 74, 48, 1);
    margin-right: 6px;
}
.tips-left{
    display: flex;
    align-items: center;
}
.dian-txt{
     color: rgba(16, 16, 16, 1);
    font-size: 12px;
    font-family: Roboto-regular;
}
.tips-box{
    display: flex;
    position: absolute;
    left: 158px;
    bottom: 12px;
}
.tips-box-two{
    display: flex;
    position: absolute;
    left: 71px;
    bottom: 12px;
}
.dan-xiang{
    display: flex;
    justify-content: space-between;
}
.he-ge{
    height: 14px;
    color: rgba(4, 203, 128, 1);
    font-size: 14px;
    font-family: Roboto-bold;
    font-weight: 600;
}
.dan-xiang-one{
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    font-family: Roboto-regular;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
}
.home-box{
    width: 100%;
    height: 100%;
}
.nei-rong{
    text-align: center;
    color: rgba(16, 16, 16, 1);
    font-size: 12px;
    font-family: Roboto-regular;
    position:absolute;
    bottom: 12px;
    left: 40%;
    display: flex;
    align-items: center;
}
.gong-kai{
    display: flex;
    align-items: center;
    flex: 50%;
    margin-bottom: 24px;
}
.gong-kai-num{
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    font-family: Roboto-bold;
    font-weight: 600;
}
.gong-kai-txt{
    color: rgba(16, 16, 16, 1);
    font-size: 12px;
    font-family: Roboto-regular;
}
.gong-box{
    display: flex;
    justify-content: space-around;
    margin-top: 64px;
    flex-wrap: wrap;
}
.gong-img{
    width: 38px;
    height: 38px;
    margin-right: 10px;
}
.content{
  overflow-y: auto;
  background: #fff !important;
}
.el-button--primary {
  background: #176de6;
}
</style>